<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{$t('message.产品热搜榜内容编辑')}}</span>
      </div>
      <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">  
          <el-link
            :underline="false"
          >
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont" >&#xe600;</i>
              {{$t('message.返回')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-show="!isEditMode && !isInit"
          >
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont" >&#xe618;</i>
              {{$t('message.修改')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-show="isEditMode"
          >
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont" >&#xe769;</i>
              {{$t('message.保存')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-show="!isInit"
          >
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont" >&#xe667;</i>
              {{$t('message.刷新')}}
            </el-button>
          </el-link>
        </div>
        <!-- <el-divider></el-divider> -->
      </div>
      </div>
      <div class="grid-content subtitle">
        <span>{{$t('message.产品信息')}}</span>
      </div>
      <div v-if="isInit" class="grid-content content-margin">
        <div class="buttonarea">  
          <el-link
            :underline="false"
          >
            <el-button size="medium" round @click="selectTarget">
              <i class="iconfont" >&#xe727;</i>
              {{$t('message.选择产品')}}
            </el-button>
          </el-link>
        </div>
      </div>
      <div class="grid-content content-margin">
        <el-table
          ref="table"
          :data="tableData"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            prop="shelvesid"
            :label="$t('message.产品ID')"
            width="150">
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('message.产品名称')"
            min-width="150"
            >
          </el-table-column>
          <el-table-column
            :label="$t('message.品牌名称')"
            min-width="150"
            >
            <template slot-scope="scope">
                <span>{{getBrandName(scope.row.brandid)}}</span>
            </template>
          </el-table-column>
          <el-table-column  :label="$t('message.产品图片')" width="150" align="center">
            <template slot-scope="scope">
                <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover">
                  <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                  <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
                </el-popover>
                <span v-else>{{$t('message.无')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="shelvesinfo"
            :label="$t('message.产品描述')"
            min-width="200"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            min-width="200"
            prop="jumpurl"
            :label="$t('message.跳转链接')"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            width="150"
            :label="$t('message.产品状态')"
            >
            <template slot-scope="scope">
              <span>{{getProductStateName(scope.row.state)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="searchcount"
            :label="$t('message.搜索次数')"
            min-width="160"
            >
          </el-table-column>
          <el-table-column
            prop="viewcount"
            :label="$t('message.浏览次数')"
            min-width="160"
            >
          </el-table-column>
        </el-table>
      </div>

      <div class="grid-content subtitle">
        <span>{{$t('message.热搜信息编辑')}}</span>
      </div>

      <div class="grid-content content-margin">
        
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.热搜状态')}}</span>
            </td>
            <td >
              <el-radio-group :disabled="!isEditMode" v-model="topstate">
                <el-radio :label="'0'">{{$t('message.普通')}}</el-radio>
                <el-radio :label="'1'">{{$t('message.火热')}}</el-radio>
                <el-radio :label="'2'">{{$t('message.新品')}}</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.箭头状态')}}</span>
            </td>
            <td >
              <el-radio-group :disabled="!isEditMode" v-model="arrowstate">
                <el-radio :label="'0'">{{$t('message.普通')}}</el-radio>
                <el-radio :label="'1'">{{$t('message.上升')}}</el-radio>
                <el-radio :label="'2'">{{$t('message.下降')}}</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.增加搜索量')}}</span>
            </td>
            <td >
              <el-input-number :min="0" :disabled="!isEditMode" size="mini" v-model="addcount"></el-input-number>
            </td>
          </tr>
          <tr v-if="!isInit">
            <td>
              <span class="simpleLabel">{{$t('message.创建日期')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="createdate"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
          <tr v-if="!isInit">
            <td>
              <span class="simpleLabel">{{$t('message.创建人')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="createid"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
          <tr v-if="!isInit">
            <td>
              <span class="simpleLabel">{{$t('message.更新日期')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="editdate"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
          <tr v-if="!isInit">
            <td>
              <span class="simpleLabel">{{$t('message.更新人')}}</span>
            </td>
            <td >
              <el-input
              readonly
              v-model="editid"
              size="mini"
              placeholder=""/>
            </td>
          </tr>
        </table>
      </div>
      <shade v-if="showShelvesStore > 0">
        <shelves-store
          v-bind:ismulti="false"
          v-bind:excludeList="excludeList"
          :key="timer"
          @onClick="onStoreClick"
        ></shelves-store>
      </shade>
    </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";
import {topfixfunc} from "@/utils/topFix";
import shelvesStore from "@/components/productStore/shelvesStore";
import shade from "@/components/shade/shade";
export default {
  name: "TopDetail",
  components: {
    shade,
    shelvesStore,
  },
  data() {
    return {
      typeOptions: [
        {
          value: "0",
          label: "加载中..",
          disabled: true,
        },
      ],
      appid: 0,
      shelvesid: 0,
      topstate: "0",
      arrowstate: "0",
      addcount: 0,
      createdate: "",
      createid: "",
      editdate: "",
      editid: "",
      tableData: null,
      excludeList: [],
      isEditMode: true,
      isInit: true,
      showShelvesStore: false,
      timer: "",
    };
  },
  mounted: function () {
    topfixfunc()
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    doSave() {
      if (this.shelvesid == 0) {
        this.$message({
          type: "error",
          message: this.$t('message.产品不能为空'),
        });
        return;
      }
      this.isEditMode = false;
      if (this.isInit) {
        rejecthttp(true,'post',"/manage/topsearches/addtop",{
            shelvesid: this.shelvesid,
            appid: this.appid,
            state: this.topstate,
            arrowstate: this.arrowstate,
            addcount: this.addcount,
            createdate: "2021-07-21T07:17:22.619Z",
            createid: 0,
            editdate: "2021-07-21T07:17:22.619Z",
            editid: 0,
          },this,(doc) => {
            changeflagCLOSED(doc,true,this)})
        // this.$http
        //   .post("/manage/topsearches/addtop", {
        //     shelvesid: this.shelvesid,
        //     appid: this.appid,
        //     state: this.topstate,
        //     arrowstate: this.arrowstate,
        //     addcount: this.addcount,
        //     createdate: "2021-07-21T07:17:22.619Z",
        //     createid: 0,
        //     editdate: "2021-07-21T07:17:22.619Z",
        //     editid: 0,
        //   })
          // .then((doc) => {
          //   // console.log(doc.data)
          //   changeflagCLOSED()
          //   if (doc.data.Code != "MSGKEY_OK") {
          //     this.$message({
          //       type: "error",
          //       message: doc.data.Message,
          //     });
          //   } else {
          //     this.$message({
          //       type: "success",
          //       message: doc.data.Message,
          //     });
          //     this.$router.go(-1); //返回上一层
          //   }
          // });
      } else {
        rejecthttp(true,'post',"/manage/topsearches/updatetop",{
            shelvesid: this.shelvesid,
            appid: this.appid,
            state: this.topstate,
            arrowstate: this.arrowstate,
            addcount: this.addcount,
            createdate: "2021-07-21T07:17:22.619Z",
            createid: 0,
            editdate: "2021-07-21T07:17:22.619Z",
            editid: 0,
          },this,(doc) => {
            changeflagCLOSED(doc,true,this)
            // console.log(doc.data)
            // if (doc.data.Code != "MSGKEY_OK") {
            //   this.$message({
            //     type: "error",
            //     message: doc.data.Message,
            //   });
            // } else {
            //   this.$message({
            //     type: "success",
            //     message: doc.data.Message,
            //   });
            // }
          })
        // this.$http
        //   .post("/manage/topsearches/updatetop", {
        //     shelvesid: this.shelvesid,
        //     appid: this.appid,
        //     state: this.topstate,
        //     arrowstate: this.arrowstate,
        //     addcount: this.addcount,
        //     createdate: "2021-07-21T07:17:22.619Z",
        //     createid: 0,
        //     editdate: "2021-07-21T07:17:22.619Z",
        //     editid: 0,
        //   })
          // .then((doc) => {
          //   // console.log(doc.data)
          //   changeflag()
          //   if (doc.data.Code != "MSGKEY_OK") {
          //     this.$message({
          //       type: "error",
          //       message: doc.data.Message,
          //     });
          //   } else {
          //     this.$message({
          //       type: "success",
          //       message: doc.data.Message,
          //     });
          //   }
          // });
      }
    },
    refresh() {
      this.$http
        .get("/manage/brand/getbrandlist", {
          params: {
            appid: "188",
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log(doc.data);
            this.typeOptions = [];
            doc.data.data.forEach((any) => {
              let item = {
                value: any.brandid,
                label: any.name,
              };
              this.typeOptions.push(item);
            });
          }
        });
      this.$http
        .get("/manage/topsearches/gettoplistsimple", {
          params: {
            appid: "188",
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log(doc.data);
            this.excludeList = doc.data.data;
          }
        });
      
      if (!this.shelvesid) {
        return;
      }
      this.$http
        .get("/manage/topsearches/gettopinfo", {
          params: {
            shelvesid: this.shelvesid,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log(doc.data);
            this.shelvesid = doc.data.data.shelvesid;
            this.name = doc.data.data.name;
            this.topstate = doc.data.data.topstate.toString();
            this.arrowstate = doc.data.data.arrowstate.toString();
            this.addcount = doc.data.data.addcount;
            this.createdate = commonUtil.formatDate(doc.data.data.createdate);
            this.createid = doc.data.data.createid;
            this.editdate = commonUtil.formatDate(doc.data.data.editdate);
            this.editid = doc.data.data.editid;
            this.tableData = [];
            this.tableData.push(doc.data.data);
          }
        });
    },
    getBrandName(id) {
      let result = "未选择";
      this.typeOptions.forEach((item) => {
        if (parseInt(item.value) == parseInt(id)) return (result = item.label);
      });
      return result;
    },
    getProductStateName(state) {
      return commonUtil.getProductStateName(state);
    },
    selectTarget() {
      this.timer = new Date().getTime();
      this.showShelvesStore = true;
    },
    onStoreClick(doc) {
      this.showShelvesStore = !this.showShelvesStore;
      if (doc.sel) {
        console.log(doc.sel);
        this.tableData = [];
        this.tableData.push(doc.sel);
        this.shelvesid = doc.sel.shelvesid;
        this.showShelvesStore = 0;
      }
    },
  },
  created() {
    this.appid = this.$route.query.appid ? this.$route.query.appid : 0;
    if (this.$route.query.id) {
      this.shelvesid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
    user-select: text!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/products/TopDetail.vue